import Icon from './Icon';

const Rotate = (props) => (
  <Icon
    {...props}
    path="M57.6809 13.175C45.8768 6.64958 31.1835 8.70704 21.6259 18.2183L12.9057 26.4122V15.5117C12.9057 13.7854 11.5063 12.386 9.77999 12.386C8.05372 12.386 6.6543 13.7854 6.6543 15.5117V33.6384C6.6543 33.6388 6.6543 33.6392 6.6543 33.6396V33.6407C6.6543 35.367 8.05372 36.7664 9.77999 36.7664H27.909C29.6353 36.7664 31.0347 35.367 31.0347 33.6407C31.0347 31.9144 29.6353 30.515 27.909 30.515H17.6685L25.9402 22.7425L26.0081 22.6767C33.5944 15.1033 45.2749 13.4599 54.6564 18.6461C64.0379 23.8322 68.8587 34.5978 66.4801 45.0501C64.1016 55.5024 55.097 63.1218 44.3952 63.7377C33.6933 64.3537 23.8741 57.8177 20.3121 47.7073C19.7384 46.0791 17.9535 45.2242 16.3253 45.7979C14.6971 46.3715 13.8423 48.1564 14.4159 49.7846C18.9032 62.5211 31.2729 70.7547 44.7544 69.9788C58.2359 69.2028 69.5793 59.6044 72.5757 46.4372C75.5721 33.27 69.4991 19.7082 57.6809 13.175Z"
    pathFillRule="evenodd"
    pathClipRule="evenodd"
  />
);

export default Rotate;
